import Vue from "vue";

const req = require.context("./api/", true, /\.(js)$/i);

req.keys().map(key => {
  const name = key.match(/\w+/)[0];
  const js = require(`@/api/${name}.js`).default;
  Vue.prototype[`$${name}`] = js;
});
